module.exports = __webpack_public_path__ + "static/media/9.f4bad422.png";